import { Dispatch, SetStateAction, useState } from "react";

import DropdownOptionWithIcon from "../../../../components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "../../../../components/Menus/PopoverDropdownMenu";
import { FileInterface } from "../../../../types/RecordInterfaces";
import { downloadFile } from "../../../../utils/FileUtils";

const ImageCardOptions = ({
  file,
  openInfo,
  deleteFile,
  onTranslate,
  onTranscribe,
}: {
  file: FileInterface;
  openInfo: () => void;
  deleteFile: (fileValue: string) => void;
  onTranscribe: (setTranscribing: Dispatch<SetStateAction<boolean>>) => void;
  onTranslate: (() => void) | undefined;
}) => {
  const [transcribing, setTranscribing] = useState(false);

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        onClick={() => downloadFile(file)}
        name="Download"
        icon="mdi mdi-download"
      />
      <DropdownOptionWithIcon
        name="Info"
        onClick={openInfo}
        icon="mdi mdi-information-outline"
      />
      {file?.Type === "application/pdf" && onTranslate && (
        <DropdownOptionWithIcon
          name="Translate"
          onClick={onTranslate}
          icon="mdi mdi-translate"
        />
      )}
      {(!!file?.Type?.startsWith("audio/") || file.Type === "video/webm") && (
        <DropdownOptionWithIcon
          name={
            file?.hasOwnProperty("Transcript") ? "Transcribed" : "Transcribe"
          }
          onClick={() => onTranscribe(setTranscribing)}
          icon={
            file?.hasOwnProperty("Transcript")
              ? "mdi mdi-checkbox-marked-circle"
              : "mdi mdi-transcribe"
          }
          disabled={transcribing || file?.hasOwnProperty("Transcript")}
        />
      )}
      <DropdownOptionWithIcon
        name="Delete"
        onClick={() => deleteFile(file.File)}
        icon="mdi mdi-delete"
      />
    </PopoverDropdownMenu>
  );
};

export default ImageCardOptions;
